<template>
  <div class="pc_only">
    <h2 class="kojin-title"><slot>タイトル</slot></h2>
  </div>
  
  <span class="sp_only">
      <span class="sp-title" style="color:blacka;background: #d8e8fc;" >
       <slot>タイトル</slot>
       <input type="text" class="form-control" v-if="GlobalData.user_name" v-bind:value="GlobalData.user_name" readonly="readonly">
          <input type="text" class="form-control" v-else-if="GlobalData.$profile" value="未登録" readonly="readonly">
          <input type="text" class="form-control" v-else value="----------------------------------------------------------------------------------" readonly="readonly">
      </span>
    </span>
  <div class="p-2" style="margin-top:0">
    <!-- パンくずリスト -->
    <nav class="pc_only" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>
        <li class="breadcrumb-item active" aria-current="page"><slot>タイトル</slot></li>
      </ol>
    </nav>

    <div id="manual_area" style="margin-bottom:10px">

    <span v-on:click="manual_open"><img class="m_icon" src="../../images/mark/manual.png"  />ログイン画面のマニュアル</span>
    <span class="pc_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png"  />システムQ&A</span>
    <span class="sp_only"  v-on:click="qanda_open"><img class="m_icon" src="../../images/mark/QandA.png" style="height:35px"  /></span>

    </div>
      <br clear="all">
    
    <div style="width:100%;margin-top:10px;display: flex;justify-content: center;">
      <p v-on:click="User_add()" class="btn btn-primary mx-aut" style="cursor:pointer;width:100%;max-width:400px; height: 50px;padding: 0;display:flex;align-items: center;justify-content: center;"  >
        新規登録はこちら
      </p>
    </div>

    <hr style="margin-top:0">
    <b  style="color:red">スマートフォンをご利用の方は、Wi-Fiをご利用の場合、ログインが正常に行われない場合があります。<br>その際は、Wi-Fiを切って再度お試しください。</b><br><br>

    <!-- Google -->
    <button class="gsi-material-button" style="width:100%;max-width:400px;height:45px;margin-bottom:10px" v-on:click="startSocialLogin('Google')">
      <div class="gsi-material-button-state"></div>
      <div class="gsi-material-button-content-wrapper">
        <div class="gsi-material-button-icon">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
            <path fill="none" d="M0 0h48v48H0z"></path>
          </svg>
        </div>
        <span class="gsi-material-button-contents">Googleでログイン</span>
        <span style="display: none;">Googleでログイン</span>
      </div>
    </button>
    <!-- Apple -->
    <div v-on:click="startSocialLogin('SignInWithApple')" 
     style="width:100%; cursor:pointer;
    display: flex;
    justify-content: center;" v-if="apple_button">
      <button class="bubble-element Button" style="display:flex;align-items: center;margin-bottom:10px;padding: 0px 12px; cursor: inherit; background: none #000000; border: none; text-align: center;  box-sizing: border-box; z-index: 24; height: 45px;width:100%;max-width:400px; top: 0px; left: 1.42109e-14px; font-size: 14px;  color: rgb(255, 255, 255); line-height: 1; border-radius: 5px; opacity: 1;">
        <img  src="../../images/Apple.png" alt="Apple" style="height:28px;padding-right:5px;"/>
        <div class="content" style="width:100%">Appleでログイン</div>
      </button>
    </div>
    <!-- LINE -->
    <div v-on:click="startSocialLogin('LINE')" 
    style="width:100%; cursor:pointer;
    display: flex;
    justify-content: center;" v-if="line_button">
      <button class="bubble-element Button" style="display:flex;align-items: center;margin-bottom:10px;padding: 0px 12px;cursor: inherit; background: none #06C755; border: none; text-align: center;  box-sizing: border-box; z-index: 24; height: 45px;width:100%;max-width:400px; top: 0px; left: 1.42109e-14px; font-size: 14px;  color: rgb(255, 255, 255); line-height: 1; border-radius: 5px; opacity: 1;">
        <img  src="../../images/LINE.png" alt="LINE" style="height:25px;"/>
        <div class="content" style="width:100%">LINEでログイン</div>
      </button>
    </div>
<!--
    <div v-on:click="startSocialLogin()" 
    style="width:100%; cursor:pointer;
    display: flex;
    justify-content: center;" v-if="line_button">
      <button class="bubble-element Button" style="display:flex;align-items: center;margin-bottom:10px;padding: 0px 12px;cursor: inherit; background: none #06C755; border: none; text-align: center;  box-sizing: border-box; z-index: 24; height: 45px;width:100%;max-width:400px; top: 0px; left: 1.42109e-14px; font-size: 14px;  color: rgb(255, 255, 255); line-height: 1; border-radius: 5px; opacity: 1;">
        <div class="content" style="width:100%">LINE・Apple・Googleでログイン</div>
      </button>
    </div>
    <div style="width:100%;text-align:center">※ソーシャルログインは調整中です。</div>
  -->

    <div class="bubble-r-line" style="
      margin: 10px 0 5px 0;
      height: 21px;
      display: flex;
      align-items: center;
      justify-content: center;">
        <div class="bubble-r-box" style="height: 9px; left: 26px;width:45% ">
          <div class="bubble-element Shape" style=" box-sizing: border-box; z-index: 24; height: 1px; top: 8px;  left: 0px; background-color: rgb(100, 100, 100); border-radius: 0px; opacity: 1;"></div>
        </div>
        <div class="bubble-r-box" style="height: 21px; left: 196px; width:10%;min-width:100px">
          <div class="bubble-element Text" style="white-space: pre-wrap;  box-sizing: border-box; z-index: 24; top: 0px; width: 100%; left: 0px; height: 21px; overflow: visible; font-family: Lato; font-size: 14px; font-weight: 400; color: rgb(51, 51, 51); text-align: center; line-height: 1; border-radius: 0px; opacity: 1;">
            <div class="content">
              または
            </div>
          </div>
        </div>
        <div class="bubble-r-box" style="height: 9px; left: 217px; width: 45%;">
          <div class="bubble-element Shape" style="box-sizing: border-box; z-index: 24; height: 1px; top: 8px; left: 0px; background-color: rgb(100, 100, 100); border-radius: 0px; opacity: 1;"></div></div></div>
    
    
        <table class="vy-form-table" id="mailform">
     
        <!-- メールアドレス -->
        <tr>
          <th style="padding:10px 20px">
            <label for="username">メールアドレス</label>
            <!-- v-model="(javascript部分で宣言した変数名)" -->
            <!-- javascript側で変数に変更があった場合、こちらの項目の値も変更される -->
            <!-- 逆にこちらの項目の値を変更すると、変数に代入される-->
            <!-- v-if="(javascript部分で宣言した変数名)" -->
            <!-- v-ifで指定された変数が「True」なら表示、「False」なら非表示 -->
            <input type="text" class="form-control" id="username" name="username" placeholder="example@mail.com" v-model="username">
          </th>
        </tr>

        <!-- パスワード -->
        <tr>
          <th style="padding:10px 20px">
            <label for="password">パスワード</label>
            <!-- v-if="pass_flag == '●●'" で、表示する項目を切り替える --> 
            <!-- pass_flag の値を動的に切り替えることで項目の表示・非表示も切り替える-->
            <input class="form-control" id="password" name="password"  type="password" v-model="password" v-if="pass_flag == 'password'" @keyup.enter.prevent="Login"   />
            <input class="form-control" id="password" name="password"  type="text" v-model="password" v-if="pass_flag == 'text'" @keyup.enter.prevent="Login"   />
            
            <div style="display: flex;padding-top: 10px;align-items: center;">
              <input type="checkbox" v-model="pass_flag" true-value="text" false-value="password" style="height:20px;width:20px"/>&nbsp;&nbsp;パスワードを表示する
            </div> 
          </th>
        </tr>
        <tr>
          <td>
            <div class="container">
              <div class="row justify-content-center">
                <div class="col-md-auto" style="display: flex;justify-content: center;">
                  <!-- v-on:〇〇="(javascript部分で宣言した関数)" -->
                  <!-- 「v-on:〇〇」は「on〇〇」であり、「onclick」は「v-on:click」、「onchange」は「v-on:change」となる -->
                  <button type="submit" class="btn btn-primary mx-aut" style="width: 200px; height: 50px;padding: 0;" v-on:click="Login()" >ログイン</button>
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td style="text-align: center;">
            <p v-on:click="Pass_forgot()" style="cursor:pointer;margin-bottom:10px" ><u>パスワードを忘れた場合はこちら</u></p>
          </td>
        </tr>
      </table>

      
    </div>

      
      <!--メッセージを表示するモーダルウィンドウ-->
      <component v-bind:is="contentMessage"
                v-bind:message_text="message"
                v-bind:message_cat="message_cat"
                v-bind:message_flag="message_flag"
                @close_message="Close_message"
                @ok_message="OK_message"/>
</template>


<script setup>
/* eslint-disable */
import FooterArea from '../common/FooterArea.vue'
import MessageModal from '../common/MessageModal.vue'
import { GlobalData, login_check,logout } from '../js/userdata.js';
import {
    CognitoUserPool,
    CognitoUser,
    AuthenticationDetails } from 'amazon-cognito-identity-js'
import { signInWithRedirect, signOut } from "aws-amplify/auth";
import AWS from 'aws-sdk'
import axios from 'axios'
import { ref,nextTick  } from 'vue'
const prop = defineProps(['param'])
const emit = defineEmits(['call'])
import { useRouter, useRoute } from 'vue-router'
const router = useRouter();
const route = useRoute();

import { useCookies } from 'vue3-cookies'
const { cookies } = useCookies()

const cityname = route.params.shakyo

let apple_button = ref(true)
let line_button = ref(true)

let checkin_url = location.hostname

// 属性リスト
let attributeList = [];
const title = "ログイン";

var poolData = {
            UserPoolId : GlobalData.$UserPoolId,
            ClientId : GlobalData.$ClientId
    };
    var userPool = new CognitoUserPool(poolData);
    var cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
        // ログアウト
        cognitoUser.signOut();
        GlobalData.$User_email = "";
        //alert("ログアウトしました。");
    }


// 入力された項目
let username = "";           //ユーザー名（メールアドレス）
let password = "";           //パスワード
const pass_flag = ref("password");  //パスワードのタイプ切替

/* メッセージを表示するモーダルウィンドウ */
let message = ref("")//表示するメッセージ
let message_cat = ref(0)// メッセージのカテゴリ（0：OKのみ、1：OK or キャンセルの選択式）
let message_method = ref("")// こちら（親コンポーネント）に帰った時、どの処理（関数）を行うのか（message_catが1の時のみ）
let message_flag = ref(false)//表示・非表示フラグ
/* 表示する子コンポーネント関係の情報 */
const contentMessage = ref('')// 表示する子コンポーネントの情報（メッセージ表示エリア）
contentMessage.value = null // 表示する子コンポーネント


/* 関数の記述 */
let Page_scroll_login = function(){
// ページの一番上にスクロールする
//「behavior: 'smooth'」はスムーズなスクロール。「behavior: 'auto'」だと一瞬で移動する
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    })
}


let Login = function() {  // ログイン情報を送信する
    var ref = this
    let error_message = "";

    // メールアドレスが入力されているかどうかの確認      
    let mail_regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;//example@mail.comの形式になっているかどうかの確認用
    if(username == ""){
        error_message += "メールアドレスが未入力です。\n"
    }else if (!mail_regex.test(username)) {
        error_message += "メールアドレス以外の値が入力されています。\n"
    }

    // パスワードが入力されているかどうかの確認
    if(password == ""){
        error_message += "パスワードが未入力です。"        
    }

    // エラーメッセージがあったら処理中断
    if(error_message != ""){
        message.value = error_message;
        message_cat.value = 0;
        message_flag.value = true;
        message_method.value = "validation_error";
        contentMessage.value = MessageModal
        return;
    }

    loginWithEmail()

}

//—- メールログイン —----------------------------------------
const loginWithEmail = async () => {
  
  cookies.remove('provider'); 
  try {
    const res = await axios.post("/dev/auth_lambda", { email: username, password: password});
    console.log(JSON.stringify(res))
    //alert("メールログイン成功");
    login_check()
    setTimeout(function(){url_check()}, "1000");
  } catch (err) {
  console.error(err);
    alert("ログインに失敗しました。メールアドレスかパスワードに不備があります。");
  }
};


let url_check = function(){

  // URLがログインだった場合かつ管理ユーザーではない場合はhomeへ
  
  if(route.path == "/"+cityname+"/Taiken/login"){
    router.push("/"+cityname+"/Taiken")
  }else if(route.path == "/"+cityname+"/Taiken/mypage"){
    
    // ローディングアイコンを表示
    emit('call', { cmd:'mypage'})

  }else{
    location.reload()
  }
}
 
const clientId = GlobalData.$social_ClientId;
const cognitoDomain = GlobalData.$cognitoDomain;
const redirectUri = location.protocol+"//"+location.host+"/redirect";
const scopes = ["openid", "email", "profile", "aws.cognito.signin.user.admin"];
// 1. ソーシャルログイン開始
function startSocialLogin(provider) {
  
  // ソーシャルログイン時、戻る社協英名を保存
  localStorage.setItem('return_shakyo', cityname)
  if(route.params.cmd == "checktaiken" || route.params.cmd == "checkjizen" || route.params.cmd == "checkjigo" ){
    localStorage.setItem('checkin', route.params.cmd)
    localStorage.setItem('checkin_id', route.params.id)
  }
  cookies.remove('provider'); 
  localStorage.setItem('set_provider', provider)


  const url = new URL(`https://${cognitoDomain}/oauth2/authorize`);
  if (provider != "mail") {
    url.searchParams.set("identity_provider",provider); // プロバイダ名を指定
  }
  url.searchParams.set("response_type", "code"); // 認可コードフロー
  url.searchParams.set("client_id", clientId);
  url.searchParams.set("redirect_uri", redirectUri);
  url.searchParams.set("scope", scopes.join(" "));
  url.searchParams.set("state", provider);
  window.location.href = url.toString();
}


//-------- ソーシャルログイン関係 -------- 
function handleSignIn(set_provider) {

  // ローディングアイコンを表示
  emit('call', { cmd:'social_login'})

  // ソーシャルログイン時、戻る社協英名を保存
  localStorage.setItem('return_shakyo', cityname)
  if(route.params.cmd == "checktaiken" || route.params.cmd == "checkjizen" ){
    localStorage.setItem('checkin', route.params.cmd)
    localStorage.setItem('checkin_id', route.params.id)
  }
  localStorage.setItem('set_provider', set_provider)

  if(set_provider == "LINE"){
    try {
      signInWithRedirect({
        provider: { custom: GlobalData.$LINE_text }, 
      });
    } catch (error) {
      console.log('error signing in: ', error);
    }
  }else{
    try {
      signInWithRedirect({
        provider: set_provider,
      });
    } catch (error) {
      console.log('error signing in: ', error);

    }
  }
      
  setTimeout(function(){emit('call', { cmd:'loading_end'})}, "10000");
  
}

let OK_message = function(){ // メッセージを表示するウィンドウでOKを押された時
    Close_message();//メッセージを表示するウィンドウを閉じる
}

let Close_message = function(){ // メッセージを表示するウィンドウを閉じる
    message_flag.value = false;
    contentMessage.value = null
}

//------------ リンク
let User_add = function(){
  location.href = location.protocol+'//'+location.host+"/"+cityname+"/Taiken/user_signin"
}

let Pass_forgot = function(){
  location.href = location.protocol+'//'+location.host+"/"+cityname+"/Taiken/forgot"
}

const home = () => {
  location.href = location.protocol+'//'+location.host+"/"+cityname+"/Taiken"
}

let manual_open = function(){
 
 let url = "https://zest-newsprint-e3e.notion.site/15ec0be34f8f802385a5fa78c1c02509"
 window.open(url,"_blank")
}

// Q&Aを開く
const qanda_open = () =>{

let url = "https://zest-newsprint-e3e.notion.site/Q-A-175c0be34f8f801998fac72f169fb66b"
window.open(url,"_blank")
}   


// ページトップへスクロール
Page_scroll_login();
</script>

<style scoped>
	#mailform{
		max-width: 800px;
		margin: auto;
		border: 1px solid #000;
	}
	#mailform tr th{
		padding: 20px;
	}
	#mailform tr td{
		padding-bottom: 15px;
	}
	.checkbox-inline input{
		margin-left: 2px;
		margin-right: 5px;
	}

  .bubble-r-line {
    clear: both;
    pointer-events: none;
  }
  .bubble-r-line .bubble-r-box {
    top: 0;
    pointer-events: none;
}
  /* Googleのログインボタン */
  .gsi-material-button {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    -webkit-appearance: none;
    background-color: WHITE;
    background-image: none;
    border: 1px solid #747775;
    -webkit-border-radius: 4px;
    border-radius: 4px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #1f1f1f;
    cursor: pointer;
    font-family: 'Roboto', arial, sans-serif;
    font-size: 14px;
    height: 40px;
    letter-spacing: 0.25px;
    outline: none;
    overflow: hidden;
    padding: 0 12px;
    text-align: center;
    -webkit-transition: background-color .218s, border-color .218s, box-shadow .218s;
    transition: background-color .218s, border-color .218s, box-shadow .218s;
    vertical-align: middle;
    white-space: nowrap;
    width: auto;
    max-width: 400px;
    min-width: min-content;
  }

  .gsi-material-button .gsi-material-button-icon {
    height: 20px;
    margin-right: 12px;
    min-width: 20px;
    width: 20px;
  }

  .gsi-material-button .gsi-material-button-content-wrapper {
    -webkit-align-items: center;
    align-items: center;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: row;
    -webkit-flex-wrap: nowrap;
    flex-wrap: nowrap;
    height: 100%;
    justify-content: space-between;
    width: 100%;
  }

  .gsi-material-button .gsi-material-button-contents {
    -webkit-flex-grow: 1;
    flex-grow: 1;
    font-family: 'Roboto', arial, sans-serif;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: top;
  }

  .gsi-material-button .gsi-material-button-state {
    -webkit-transition: opacity .218s;
    transition: opacity .218s;
    bottom: 0;
    left: 0;
    opacity: 0;
    right: 0;
    top: 0;
  }

  .gsi-material-button:disabled {
    cursor: default;
    background-color: #ffffff61;
    border-color: #1f1f1f1f;
  }

  .gsi-material-button:disabled .gsi-material-button-contents {
    opacity: 38%;
  }

  .gsi-material-button:disabled .gsi-material-button-icon {
    opacity: 38%;
  }

  .gsi-material-button:not(:disabled):active .gsi-material-button-state, 
  .gsi-material-button:not(:disabled):focus .gsi-material-button-state {
    background-color: #303030;
    opacity: 12%;
  }

  .gsi-material-button:not(:disabled):hover {
    -webkit-box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
    box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
  }

  .gsi-material-button:not(:disabled):hover .gsi-material-button-state {
    background-color: #303030;
    opacity: 8%;
  }
  /* Googleここまで */
</style>